/**
 * Specifically for tooltips: Strips HTML tags but preserves line breaks by replacing <br> with newlines.
 */
export const stripHtmlForTooltip = (html: string | null | undefined): string => {
  if (!html) return '';
  
  // Replace <br> and variants with newlines before stripping other tags
  const withNewlines = html.replace(/<br\s*\/?>/gi, '\n');
  
  const doc = new DOMParser().parseFromString(withNewlines, 'text/html');
  return doc.body.textContent || '';
};
